import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { supportedLanguages, languageNames, type SupportedLanguage } from '@/i18n';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams<{ lang: string }>();

  const currentLanguage = (lang as SupportedLanguage) || (i18n.language as SupportedLanguage) || 'fr';

  const changeLanguage = useCallback((newLang: SupportedLanguage) => {
    // Change i18n language
    i18n.changeLanguage(newLang);
    
    // Update URL with new language
    const pathWithoutLang = location.pathname.replace(/^\/(fr|en|es)/, '') || '/';
    const newPath = `/${newLang}${pathWithoutLang === '/' ? '' : pathWithoutLang}`;
    
    navigate(newPath + location.search, { replace: true });
  }, [i18n, navigate, location]);

  const getLocalizedPath = useCallback((path: string) => {
    // Remove leading slash if present for concatenation
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `/${currentLanguage}${cleanPath ? `/${cleanPath}` : ''}`;
  }, [currentLanguage]);

  return {
    currentLanguage,
    changeLanguage,
    getLocalizedPath,
    supportedLanguages,
    languageNames
  };
};
